import { render, staticRenderFns } from "./_CreateHabilitation.vue?vue&type=template&id=6c71087d&"
import script from "./_CreateHabilitation.vue?vue&type=script&lang=ts&"
export * from "./_CreateHabilitation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports